import { partnerCenterTheme, createScope, cssUtilities } from '@harmony/enablers/react';
import React from 'react';

// Create a global scope as its required to create a custom scope on a standAlone app
const scope = createScope({
  rootElement: document.querySelector('#MemSellerExperienceMainContent')!,
  suffix: 'mem',
  basePath: `${import.meta.env.VITE_PUBLIC_URL}/static/enablers`,
  reactInstance: React,
  styles: [partnerCenterTheme, cssUtilities],
});

export default scope;
